// extracted by mini-css-extract-plugin
export default {"customModal":"Modals_customModal__U54Ul"};